import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';
import { nameResolver } from '@/_shared';

import { useGetContactsMutation } from '../apis';
import type { ContactQueryLinkerSchema } from '../schemas';

type FormContactsAsyncMultiSelectProps = FormAsyncComboboxProps<ContactQueryLinkerSchema, true>;

export function FormContactsAsyncMultiSelect(props: FormContactsAsyncMultiSelectProps) {
  const itemToString = useCallback((item?: ContactQueryLinkerSchema | null): ReactNode => {
    if (!item) {
      return '';
    }
    return nameResolver(item.first_name, item.last_name);
  }, []);

  const keyExtractor = useCallback((item?: ContactQueryLinkerSchema | null) => item?.id?.toString() ?? '', []);

  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      itemToString={itemToString}
      keyExtractor={keyExtractor}
      useApi={useGetContactsMutation}
      menuPortalTarget={null}
    />
  );
}
